import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/authFetch';

export default function LotEnvironmentalFee({ stockId, partId, quantity }) {
  const [profile,setProfile]=useState(null);
  const [error,setError]=useState('');
  useEffect(() => {
    let active=true; setProfile(null); setError('');
    if (!stockId && !partId) return undefined;
    const url=stockId ? `/environmental-fees/lots/${stockId}` : `/environmental-fees/articles/${partId}`;
    authFetch(url).then(data => { if(active)setProfile(stockId ? data : data?.profile); })
      .catch(() => {if(active)setError('Taxa de mediu nu a putut fi verificată.');});
    return () => {active=false;};
  },[stockId,partId]);
  if(error)return <small className="text-warning d-block">{error}</small>;
  if(!profile?.enabled)return null;
  const qty=Number(quantity||0);
  const rate=Number(profile.rate_per_unit ?? (Number(profile.kg_per_unit)*Number(profile.rate_per_kg)));
  const unit=profile.unit_label || 'UM';
  return <small className="text-info d-block">{profile.label}: {qty.toLocaleString('ro-RO',{maximumFractionDigits:6})} {unit} × {rate.toLocaleString('ro-RO',{maximumFractionDigits:6})} lei/{unit} = {(qty*rate).toFixed(2)} lei{profile.accounting_treatment==='producer_importer' ? ', obligație AFM proprie înregistrată manual, exclusă din costul recepției' : ', inclusă în costul stocului'}{!stockId && profile.accounting_treatment!=='producer_importer' && ' (se adaugă la prețul introdus la salvare)'}.</small>;
}
